import {Directive, ElementRef, Input, OnInit} from '@angular/core';
import {Keyboard} from '@ionic-native/keyboard/ngx';

@Directive({
    selector: '[appAutofocus]'
})
export class AutofocusDirective implements OnInit {
    private focus = true;

    constructor(private el: ElementRef, private keyboard: Keyboard) {
    }

    ngOnInit() {
        if (this.focus) {
            this.el.nativeElement.setAttribute('readonly', 'readonly');
            window.setTimeout(() => {
                this.el.nativeElement.focus();
                this.keyboard.hide();
                setTimeout(() => {
                    this.el.nativeElement.removeAttribute('readonly');
                }, 200);
            });
        }
    }

    @Input() set autofocus(condition: boolean) {
        this.focus = condition !== false;
    }
}